"use strict";

var React = require('react');
var ReactForms = require('react-forms');
var Mapping = ReactForms.schema.Mapping;
var List  = ReactForms.schema.List;
var email = require('email-validation');

var i18n = require('ofs/i18n');
var gettext = i18n.gettext;

var Scalar = require('ofs/forms/scalars/Scalar');
var EmailScalar = require('ofs/forms/scalars/EmailScalar');

var FormElement = ReactForms.Element;
var Row = require('ofs/forms/layout/row');
var Column = require('ofs/forms/layout/column');


var messages = {
  EMAIL_LABEL: gettext('Email address'),
  EMAIL_ERROR: gettext('Must be a valid email address'),
  SIGNUP_LABEL: gettext('Send me emails with news and promotions')
};


var mapping = function(defaultValues) {
  return {
    email: EmailScalar({
      label: messages.EMAIL_LABEL,
      defaultValue: defaultValues.get('email', null),
      required: true
    }),
    signup: Scalar({
      type: 'bool',
      defaultValue: true,
      label: messages.SIGNUP_LABEL
    })
  };
};

var layout = function(value) {
  return [
    <Row>
      <Column size="full"><FormElement className="bdd-enquire-modal-field-email" value={value.get('email')} /></Column>
    </Row>,
    <Row>
      <Column size="full"><FormElement className="bdd-enquire-modal-field-subscribe" value={value.get('signup')} /></Column>
    </Row>
  ];
};

module.exports = {mapping, layout};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/contact/mappings/email.jsx
 **/